import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const Ordlista = lazy(() => import("@/pages/info/Ordlista"));

export const Route = createFileRoute("/ordlista/")({
  head: () => seoHead("/ordlista", { description: "Vår ordlista förklarar över 90 begrepp inom elavtal, elnät, solceller, batterier, elbilsladdning och värmepumpar – med länkar till fördjupning." }),
  component: () => <Ordlista />,
});
